<!--  系统日志-->
<template>
  <div class="systemLog">
    <el-row class="tableHearInputBox" type="flex" justify="space-between">
      <el-col>
        <el-input v-model.trim="query.query" placeholder="请输入用户名" style="width: 200px" @keyup.enter.native="tableLoad" @clear="
            query.query = '';
            tableLoad();
          " clearable suffix-icon="el-icon-search"></el-input>
        <Debounce>
          <el-button style="margin:0px 10px;" size="small" @click="tableLoad">查询</el-button>
        </Debounce>
        
      </el-col> 
      <el-button size="small" type="primary" @click="toExport">导 出</el-button>
    </el-row>
    <el-table :data="tableList" tooltip-effect="dark" border ref="elTable" style="width: 100%;" :header-cell-style="$store.getters.getTableHeadStyle" v-loading="tableIsLoad" element-loading-text="加载中" :height="$store.getters.getTableHeight">
      <el-table-column prop="userName" label="用户名" :min-width="100" align="center"></el-table-column>
      <el-table-column prop="operation" label="操作名称" :min-width="150" align="center"></el-table-column>
      <el-table-column prop="params" label="操作内容" :min-width="400" align="center"></el-table-column>
      <el-table-column prop="createDate" label="操作时间" align="center" width="230">
        <template slot-scope="scope">
          {{$tagTime(scope.row.createDate,'yyyy年MM月dd日 HH时mm分ss秒')}}
        </template>
      </el-table-column>
    </el-table>
    <Pagination :total="query.total" :page.sync="query.pageNum" :limit.sync="query.pageSize" class="pagination-content" @pagination="tableLoad" />

  </div>
</template>

<script>
export default {
  data() {
    return {
      tableList: [],
      tableIsLoad: true,
      logTypeList: [
        { id: "", name: "全部日志" },
        { id: 1, name: "登录日志" },
        { id: 2, name: "操作日志" },
        { id: 3, name: "异常日志" },
      ],
      query: {
        query: "",
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, //总条数
        type: "", //日志类型
        time: [],
      },
      visible:false,
      fileUploadType:1,
      examFile:null,
      stuFile:null,
    };
  },
  mounted() {
    this.tableLoad();
  },
  filters: {
    getLogType(val) {
      let type = ["全部日志", "登录日志", "操作日志", "异常日志"];
      return type[val * 1];
    },
  },
  methods: {
    toExport() {
      // this.$axios.post("log/list", this.query).then((res) => {
      // });
      this.$axios
        .post("log/export", this.query, { responseType: "blob" })
        .then((res) => {
          this.$exportFile(res);
        });
    },
    tableLoad() {
      this.$axios.post("log/list", this.query).then((res) => {
        let { list, total } = res.data.data;
        this.tableList = list;
        this.query.total = total;
        this.tableIsLoad = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.systemLog {
  .el-range-editor.el-input__inner {
    padding: 0px 10px;
  }
  .dateTimeSelect {
    margin-left: 10px;
  }
  .fileRow{
    display: flex;
    padding: 0px 20px 20px 20px;
    span{
      width: 180px;
      text-align: right;
      margin-right: 10px;
    }
    .butBox{
      flex: 1;
      .el-button{
        color: #409EFF;
        border-color: #c6e2ff;
        background-color: #ecf5ff;
        margin: 20px 0px;
      }
      .iconfont{
        font-size: 30px;
      }
      .pdfBox{
        display: flex;
        overflow: hidden;
        width: 140px;
        p{
          cursor: pointer;
           display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .pdfBox:hover{
        .removeBut{
          transform: translateY(0px);
        }
      }
      .pdfBox1{
        width: 180px;
      }
      .removeBut{
        color: #f56c6c;
        font-size: 18px;
        cursor: pointer;
        transform: translateY(-50px);
        transition: all 0.3s 0s linear;
      }
    }
  }
}
</style>
